import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Typography from '@material-ui/core/Typography';
import MobileStepper from '@material-ui/core/MobileStepper';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import SwipeableViews from 'react-swipeable-views';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';

import {
  Close
} from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  image: {
    width: '100%',
    height: 'auto%',
  },
  content: {
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
  },
  media: {
    [theme.breakpoints.down('sm')]: {
      marginBottom: 36
    },
  },
  close: {
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    marginRight: 10
  }
}));

export default function Carousel(props) {

  const { items, open, onClose, selected } = props;
  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const handleNext = () =>{
    const changed = props.selected + 1;
    props.onChange(changed)
  }

  const handleBack = () => {
    const changed = props.selected - 1;
    props.onChange(changed)
  }


  return (
    <div>
    <Dialog fullScreen={fullScreen} onClose={onClose} open={open}>
      <IconButton className={classes.close} color="inherit" onClick={onClose} aria-label="close">
        <Close />
      </IconButton>
      <DialogContent className={classes.content}>
        <Hidden smDown>
          <Typography>{items[selected].caption || items[selected].description}</Typography>
        </Hidden>

        <SwipeableViews>
          <div className={classes.media}>
            <img className={classes.image} src={items[selected].image || items[selected].imageUrl} alt={items[selected].caption || items[selected].description} />
          </div>
        </SwipeableViews>

        <Hidden smDown>
        <MobileStepper
          steps={items.length}
          position="static"
          variant="text"
          activeStep={selected}
          nextButton={
            <Button size="small" onClick={handleNext} disabled={selected === items.length - 1}>
              Next
              <KeyboardArrowRight />
            </Button>
          }
          backButton={
            <Button size="small" onClick={handleBack} disabled={selected === 0}>
              <KeyboardArrowLeft />
              Back
            </Button>
          }
        />
        </Hidden>
      </DialogContent>
    </Dialog>
    </div>
  )
}
